import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { getCheckIfSenderEmailUsedApi } from '../api/mailing-settings-sender-emails-api'
import { SenderEmailAddressId } from '../types/sender-email-address-interface'

export function useCheckIfSenderEmailUsed() {
  const { fetcher } = useFetch<RequestMethodsEnum.get, { isUsed: boolean }>({
    method: RequestMethodsEnum.get,
  })

  const checkIfSenderEmailUsed = (id: SenderEmailAddressId) =>
    fetcher(getCheckIfSenderEmailUsedApi(id))

  return { checkIfSenderEmailUsed }
}
